import { Location } from "graphql.generated";

import { environment } from "../../../../environments/environment";
import { CalculateDistanceQuery } from "../../../../generated/graphql.generated";
import { LocationType } from "../../../global.constants";

export interface ServiceArea {
  id: string;
  name: string;
  parentId?: string;
}

export const accessTypes = [
  'none',
  'stairs',
  'elevator',
  'outdoors',
] as const;

export type AccessType = typeof accessTypes[number];

export const elevatorTypes = [
  'freight',
  'bookable',
  'not-bookable',
] as const;

export type ElevatorType = typeof elevatorTypes[number];

export type LocationEditorState = {
  selectedLocation: Partial<Location> & { setManually?: boolean };
  address: string;
  unitNumber: string;
  accessNotes?: string;
  buildingType?: string;
  size?: string;
  access?: AccessType;
  elevatorType?: ElevatorType;
  floor?: number;
  fieldsModified: boolean;
  locationModified: boolean;
}

export const jobLocationsOverviewInitialState = {
  serviceArea: undefined as ServiceArea | undefined,
  locationEditors: {} as Partial<Record<LocationType, LocationEditorState>>,
  useEndLocationAsBillingLocation: true as boolean,
  locationsSaving: {} as Record<string, true>,
  actionsMenuLocationType: undefined as LocationType | undefined,
  activeLocationType: undefined as LocationType | undefined,
  shouldFocusAutocomplete: false as boolean,
  shouldFocusWizard: false as boolean,
  shouldTouchDetailFields: false as boolean,
  calculateDistancesOutput: {
    averageTime: 0,
    estimatedTime: 0,
    totalDistance: 0,
    distanceUnits: environment.defaultUnits,
    distances: [],
  } as CalculateDistanceQuery['calculateDistance'],
} as const;

export type OverviewLocationsState = typeof jobLocationsOverviewInitialState;
